(function () {
  angular
    .module('kareo.ui.shared.modules.regex.email', [])
    .constant('EMAIL_REGEX', /^[a-zA-Z0-9!'*+_.-]+@(([a-zA-Z0-9\-]+\.)+)([a-zA-Z]{2,24}|[0-9]{1,3})$/);
})();
